import * as d3 from './d3';
import { intcomma } from 'journalize';
import { states } from '../electoral-votes';
import checkmark from '../../assets/check.svg';

class PresidentResults {
  constructor() {}
  selection(selector) {
    if (!selector) return this._selection;
    this._selection = d3.select(selector);
    return this;
  }
  data(obj) {
    if (!obj) return this._data;
    this._data = obj;
    return this;
  }
  props(obj) {
    if (!obj) return this._props || this.defaultProps;
    this._props = { ...this.defaultProps, ...this._props, ...obj };
    return this;
  }
  handleTooltip() {
    const scale = $1('.ev-scale__bar');
    const tooltip = $1('.scale-tooltip');

    scale.on('mousemove', function (e) {
      if (e.target == e.currentTarget) return;
      let stateDiv = e.target;

      if (!stateDiv.dataset.won) return;

      tooltip.classList.add('scale-tooltip--visible');

      // Places tooltip
      const rect = stateDiv.parentElement.getBoundingClientRect();
      const y = e.clientY - rect.top + 10;
      const x = e.clientX - rect.left + 10;


      tooltip.style.setProperty('top', y +'px');
      tooltip.style.setProperty('left', x + 'px');

      if (tooltip.dataset.curr !== stateDiv.dataset.state) {
        tooltip.dataset.curr = stateDiv.dataset.state;
        tooltip.querySelector('.scale-tooltip__state').innerText =
          states[stateDiv.dataset.state];

        tooltip.querySelector('.votes__value').innerText =
          stateDiv.dataset.votes;

        tooltip.querySelector('.winner__value').innerText =
          stateDiv.dataset.won || 'Undecided';

        d3.select('.scale-tooltip .winner__value')
          .classed('--biden', stateDiv.dataset.won == 'Biden')
          .classed('--trump', stateDiv.dataset.won == 'Trump');
      }
    });

    scale.on('mouseleave', function () {
      tooltip.classList.remove('scale-tooltip--visible');
    });
  }
  render() {
    const data = this.data();
    const evResults = this.selection();
    const totalEV = 538;

    const es = d3.select('.elections-2020').attr('data-es') === 'true';

    const scale = evResults.appendSelect('div', 'pres-ev__scale')

    scale.appendSelect('div', 'ev-scale__finish-line');

    scale
      .appendSelect('div', 'ev-scale__bar')
      .selectAll('div.bar__segment')
      .data(data.PresStateByStatetable.State)
      .join('div')
      .attr('class', 'bar__segment')
      .style('width', d => `${(+d.ElectTotal / totalEV) * 100}%`)
      .attr('data-state', d => d.PostalCode)
      .attr('data-votes', d => d.ElectTotal)
      .attr('data-won', ({ Cand, PostalCode }) => findWinner(Cand, PostalCode));

    // Shows total EV
    evResults
      .selectAll('.totals__group')
      .select('.group__ev-votes')
      .text(function () {
        let cand = data.Sumtable.Cand.find(d => d.name == this.dataset.name);
        return cand.ElectWon;
      });

    // Shows total popular votes
    evResults
      .selectAll('.totals__votes')
      .select('.votes__value')
      .text(function () {
        let cand = data.Sumtable.Cand.find(d => d.name == this.dataset.name);
        return intcomma(cand.PopVote);
      });

    /* ADDS LOCAL STATE POPOUT RESULTS */
    const scaleParent = evResults;

    const stateData = data.PresStateByStatetable.State.find(
      state => state.PostalCode == pageInfo['marketInfo.state_abbreviation']
    );

    const statePopout = scaleParent
      .appendSelect('div', 'pres-ev__state-popout')
      .datum(stateData);

    statePopout
      .appendSelect('span', 'popout__state-name')
      .text(pageInfo['marketInfo.state']);

    statePopout.appendSelect('span', 'popout__title').text(es ? 'Voto popular' : 'Popular Votes');


    const sortCandPopout = data => {
      if (+data.PrecinctsPct <= 0) {
        return data.Cand.filter(d => {
          return ["Biden", "Trump", "Jorgensen"].includes(d.name)
        })
      } else {
        return data.Cand.slice(0,4)
      }
    }

    const popoutCand = statePopout
      .appendSelect('div', 'popout__candidates')
      .selectAll('div.candidates__cand')
      .data(sortCandPopout(stateData))
      .join('div')
      .attr('class', 'candidates__cand');

    popoutCand
      .appendSelect('div', 'cand__name')
      .appendSelect('span', 'name__value')
      .text(d => d.name);

    popoutCand
      .filter(d => d.Winner === 'X')
      .select('.cand__name')
      .appendSelect('div', 'name__winner-wrapper')
      .appendSelect('img', 'name__winner')
      .attr('src', checkmark);

    popoutCand
      .appendSelect('span', 'cand__votes')
      .text(d => intcomma(d.PopVote));

    const precRptText = es ? 'información de los precintos' : 'precincts reporting'

    statePopout
      .appendSelect('div', 'popout__prec-rpt')
      .text(d => `${d.PrecinctsPct}% ${precRptText}`);

    this.handleTooltip();
  }
}

const findWinner = candArr => {
  let winner = candArr.find(d => d.Winner);
  if (winner) {
    return winner.name;
  } else {
    return null;
  }
};

export default PresidentResults;
